import { render, staticRenderFns } from "./skuList.vue?vue&type=template&id=e5125d0e"
import script from "./skuList.vue?vue&type=script&lang=js"
export * from "./skuList.vue?vue&type=script&lang=js"
import style0 from "./skuList.vue?vue&type=style&index=0&id=e5125d0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports